import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { HistoryQuery } from '@shared/party/models';
import { ApiResponseModelWrapper } from '@tablesready/common-ui';
import { IHistoryData, IParty } from '../models';
import { ApiClientService } from '@tablesready/api-client';

export interface HistoryApiResponse {
  data: HistoryDataApiResponce;
  success: boolean;
}

export interface HistoryDataApiResponce {
  count: number;
  parties: Array<IParty>;
}

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(private readonly http: ApiClientService) {
  }

  history(data: IHistoryData): Observable<any> {
    const defaultData = {
      page: 1,
      limit: 40,
      type: '',
      search: '',
      sort: {
        close_time: -1
      }
    };
    const requestData = Object.assign(defaultData, data);
    const {page, limit, type, search, sort} = requestData;

    let params: HistoryQuery & {[key: string]: any} = {
      page,
      limit,
      search,
      sort: JSON.stringify(sort),
    };

    if (type) {
      params.type = type;
    }

    return this.http.get<ApiResponseModelWrapper<HistoryApiResponse>>('/v.1/history', {params}).pipe(
      map(({success, error, data}) => {
        if (success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );

  }
}
